import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient"
import { PaginationResponse, ResponseData } from "../types/_public";
import { ICategory, IPostCategory, IPostCategoryKeywords } from "../types/newshub/_category";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";

const api = new APIClient();

const path_category = PATH_NEWSHUB_API + '/category';

const categoryApi = {
  categories(params: any): Promise<AxiosResponse<ResponseData<ICategory[]> & PaginationResponse, any>> {
    const url = `${path_category}`
    return api.get(url, params)
  },
  allCategoriesType(params: any = {}): Promise<AxiosResponse<ResponseData<ICategory[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/category-types`
    return api.get(url, params)
  },
  allCategoriesByType(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICategory[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/categories`;
    return api.get(url, params);
  },
  category(id: number | string, params: any = {}): Promise<AxiosResponse<ICategory, any>> {
    const url = `${path_category}/${id}`
    return api.get(url, params)
  },
  postCategory(dataForm: any): Promise<AxiosResponse<ResponseData<IPostCategory>, any>> {
    const url = `${PATH_NEWSHUB_API}//categories`;
    return api.post(url, dataForm)
  },
  postCategoryKeywords(dataForm: any): Promise<AxiosResponse<ResponseData<IPostCategoryKeywords>, any>> {
    const url = `${PATH_NEWSHUB_API}//categories/keywords`;
    return api.post(url, dataForm)
  },
  putCategory(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICategory>, any>> {
    const url = `${path_category}/${id}`;
    return api.post(url, dataForm)
  },
  deleteCategory(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICategory>, any>> {
    const url = `${path_category}/${id}`;
    return api.delete(url, dataForm)
  },
  exportFileCategory(params: any = {}): Promise<AxiosResponse<ICategory, any>> {
    const url = `${PATH_NEWSHUB_API}/exports/categories`
    return api.get(url, params)
  },
}

export default categoryApi
